import * as React from 'react';
import { Information } from '../../components/Carousel/parts/Information';
import { Header0, InlineText4, Header2 } from '@cian/ui-kit/typography';
import { setNoteForTitle } from './helpers';
import { ButtonLink } from '../../components/Button';

interface ISlideInformationProps {
  title: string | null | undefined;
  label: string | null | undefined;
  url: string | null | undefined;
  hasCommercialProperty: boolean;
}

export function SlideInformation({ title, label, url, hasCommercialProperty }: ISlideInformationProps) {
  const preparedTitle = setNoteForTitle(title || '', hasCommercialProperty);

  return (
    <Information
      title={
        title ? (
          <Header0 as="h1" color="white_100" fontWeight="bold">
            {preparedTitle}
          </Header0>
        ) : null
      }
      label={
        label ? (
          <Header2 color="white_100" fontWeight="bold">
            {label}
          </Header2>
        ) : null
      }
      chooseApartment={url ? <ButtonLink href={url}>Выбрать квартиру</ButtonLink> : null}
      note={
        hasCommercialProperty ? (
          <InlineText4 color="white_100">*в проекте есть в продаже коммерческая недвижимость</InlineText4>
        ) : null
      }
    />
  );
}
